
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class LinkedActivityCheckableIcon extends Vue {
  @Prop({ default: false })
  checked!: boolean;
}
